import { BooksUIProvider } from "./BooksUIContext";
import { BooksCard } from "./BooksCard";

export function BooksPage({ history }) {
  const booksUIEvents = {
    openNewBookPage: () => {
      history.push("/kitaplar/ekle");
    },
    openEditBookPage: (id) => {
      history.push(`/kitaplar/duzenle/${id}`);
    },
  };
  
  return (
    <BooksUIProvider booksUIEvents={booksUIEvents}>
      <BooksCard />
    </BooksUIProvider>
 );
}